import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, locationStockChangesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, locationStockChangesActions);

export default slice.reducer;
